export class BaseCredentialApplicationReportModel {
  public id: string;
  public externalSystemId: string;
  public credentialApplicationDefinitionId: string;
  public credentialApplicationType: string;
  public credentialApplicationNumber: string;
  public credentialApplicationStartDate: Date;
  public credentialApplicationEndDate?: Date;
  public credentialApplicationUpdatedBy: string;
  public credentialApplicationUpdatedOn: Date;
  public credentialApplicationCreatedBy: string;
  public credentialApplicationCreatedOn: Date;
  public credentialDefinitionId: string;
  public credentialName: string;
}
